import type { quoteMisc as enQuoteMisc } from "../en/quoteMisc";

export const quoteMisc: typeof enQuoteMisc = {
  duplicate: {
    internalNotePrefix: "Duplicato dal preventivo {{number}}.",
  },
  import: {
    heading: "Importazione in blocco preventivi",
    step1: {
      heading: "Passaggio 1 — Carica un CSV",
      intro:
        "Una riga per ogni voce. Più righe con lo stesso {{column}} vengono unite in un unico preventivo. Verificheremo i dati rispetto al tuo catalogo Shopify alla conferma — le righe non valide vengono saltate.",
      requiredColumnsLabel: "Colonne obbligatorie:",
      optionalColumnsLabel: "Facoltative:",
    },
    errors: {
      tierRequired: "È richiesto il piano STARTER o superiore.",
      emptyFile: "Carica un file CSV non vuoto.",
      fileTooLarge: "Il file supera il limite di {{mb}}MB.",
      noFile: "Nessun file caricato.",
      previewLost: "Ricarica il CSV — lo stato dell'anteprima è andato perso.",
      noValidQuotes: "Nessun preventivo valido da importare.",
      tooManyQuotes: "Troppi preventivi in un'unica importazione ({{count}} > {{max}}).",
    },
    parsingLabel: "Analisi in corso…",
    previewLabel: "Anteprima",
    step2: {
      heading: "Passaggio 2 — Anteprima ({{good}}, {{errors}})",
      goodOne: "{{count}} preventivo valido",
      goodOther: "{{count}} preventivi validi",
      errorOne: "{{count}} errore di riga",
      errorOther: "{{count}} errori di riga",
    },
    unknownHeadersBanner: "Non abbiamo riconosciuto queste colonne e le abbiamo ignorate:",
    lineCountOne: "{{count}} riga",
    lineCountOther: "{{count}} righe",
    andMore: "… e altri {{count}}",
    rowErrorsHeading: "Errori di riga ({{count}})",
    rowLabel: "Riga {{number}}",
    step3: {
      heading: "Passaggio 3 — Conferma",
      introOne:
        "Stai per creare {{count}} preventivo. A ciascuno verrà assegnato un nuovo numero interno (Q-N) e il riferimento esterno sarà registrato nella nota interna.",
      introOther:
        "Stai per creare {{count}} preventivi. A ciascuno verrà assegnato un nuovo numero interno (Q-N) e il riferimento esterno sarà registrato nella nota interna.",
      importingLabel: "Importazione…",
      importOne: "Importa {{count}} preventivo",
      importOther: "Importa {{count}} preventivi",
      cancelUploadDifferent: "Annulla e carica un file diverso",
    },
  },
};
